module.exports = __webpack_public_path__ + "static/media/processActive.9211610f.png";